/**
 * Sidebar — the right column of a property card. Contains the desktop
 * Like/Reject buttons, the Property Details card and the Energy certificate
 * card (Figma 192:97). The agency card and inline contact form that used to live
 * here were replaced by these detail cards; enquiries now go through the footer
 * "Contact" button (ContactDialog).
 *
 * On mobile the Like/Reject actions are drawn over the gallery (see
 * PropertySection), so the pills here only render on desktop (`!isMobile`).
 *
 * Props:
 *   - offer    {Object}     — the offer view-model (details + energy)
 *   - onLike   {()=>void}
 *   - onReject {()=>void}
 *   - isMobile {boolean}
 */
import React from 'react';
// import { useStrings } from './i18n';        // only used by the disabled Like/Reject actions
// import { IconX, IconHeart } from './icons'; // only used by the disabled Like/Reject actions
import PropertyDetails from './PropertyDetails';
import EnergyCard from './EnergyCard';

// `onLike`, `onReject`, `isMobile` removed with the disabled Like/Reject actions.
export default function Sidebar({ offer }) {
    return (
        <aside className="rs-grid__side">
            {/* Like/Reject actions temporarily disabled (hidden per request).
                On desktop each was an icon-only circle expanding to reveal its label.
            {!isMobile && (
                <div className="rs-actions">
                    <button className="rs-action rs-action--reject" onClick={onReject} aria-label={t.reject}>
                        <IconX /><span className="rs-action__label">{t.reject}</span>
                    </button>
                    <button className="rs-action rs-action--like" onClick={onLike} aria-label={t.like}>
                        <IconHeart /><span className="rs-action__label">{t.like}</span>
                    </button>
                </div>
            )}
            */}

            <PropertyDetails offer={offer} />
            <EnergyCard offer={offer} />
        </aside>
    );
}
